<template>
  <div id="map-container">
    <help-box />
    <div id="mapbox-map" />
  </div>
</template>

<script>
import Config from '../constants/config.js'
import HelpBox from '../components/HelpBox.vue'

export default {
  name: 'Map',
  components: {
    "help-box": HelpBox,
  },
  props: {
    lat: Number,
    long: Number,
    schoolData: Array,
  },
  data() {
    return {
      map: null,
      schoolMarkers: [],
    }
  },
  watch: {
    lat(){
      this.initalizeMapboxMap(this.lat, this.long, this.schoolData);
    },
    schoolData(){
      // remove, create, add, save when schoolData prop changes
      this.removeMarkers(this.schoolMarkers)
      const schoolMarkers = this.createMarkers(mapboxgl, this.map, this.schoolData);
      this.addMarkers(schoolMarkers, this.map);
      this.schoolMarkers = schoolMarkers;
    }
  },
  methods: {
    initalizeMapboxMap(lat, long, schoolData){
      mapboxgl.accessToken = Config.MAPBOX_ACCESS_TOKEN;
      this.map = new mapboxgl.Map({
        container: 'mapbox-map',
        style: Config.MAPBOX_STYLE,
        center: [long, lat],
        zoom: Config.MAPBOX_ZOOM,
      });

      this.map.addControl(new mapboxgl.NavigationControl(), 'top-left'); // add zoom controls

      // no need to remove markers, because new map init will wipe them.  Just create, add, and save.
      const schoolMarkers = this.createMarkers(mapboxgl, this.map, schoolData);
      this.addMarkers(schoolMarkers, this.map);
      this.schoolMarkers = schoolMarkers;

      this.map.dragRotate.disable();
      // disable map rotation using touch rotation gesture
      this.map.touchZoomRotate.disableRotation();

      // Home icon initialization
      let homeIcon = document.createElement('div');
      homeIcon.className = 'home-icon';
      new mapboxgl.Marker(homeIcon)
              .setLngLat([this.long, this.lat])
              .setPopup(new mapboxgl.Popup({ offset: 25 })) // add popups
              .addTo(this.map);
    },
    removeMarkers(markers){
      markers.forEach((marker) => marker.remove());
    },
    createMarkers(mapboxgl, map, schoolData){
      return schoolData.map((marker) => {
        // create a HTML element for each feature
        let el = document.createElement('div');
        el.className = 'marker ' + marker.iconColor;
        el.id = marker.id;

        // Track clicks on school pins
        el.addEventListener('click', (e) => {
            this.$emit('pinClicked', e.srcElement.id)
        });

        // make a marker for each feature and add to the map
        return new mapboxgl.Marker(el)
                .setLngLat(marker.geometry.coordinates)
                .setPopup(new mapboxgl.Popup({ offset: 25 }) // add popups
                .setHTML('<h3>' + marker.properties.title + '</h3><p>' + marker.properties.address + '</p>'))
      });
    },
    addMarkers(schoolMarkers, map) {
      schoolMarkers.forEach((marker) => marker.addTo(map));
    }
  }
}
</script>

<style scoped>

</style>

<style>
  #map-container {
    height: 100%;
    width: 100%;
  }

  #mapbox-map {
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
  }
  svg {
    fill: #1f3561;
  }
  .marker {
    background-size: contain;
    width: 30px;
    height: 40px;
    border-radius: 50%;
    cursor: pointer;
  }
  .marker-grey {
    background-image: url('../assets/pin-grey.svg');
  }
  .marker-red {
    background-image: url('../assets/pin-red.svg');
  }
  .marker-blue {
    background-image: url('../assets/pin-blue.svg');
  }
  .marker-green {
    background-image: url('../assets/pin-green.svg');
  }
  .marker-yellow {
    background-image: url('../assets/pin-yellow.svg');
  }
  .mapboxgl-popup {
    max-width: 200px;
  }
  .mapboxgl-popup-content {
    text-align: center;
    font-family: 'Open Sans', sans-serif;
  }
  .home-icon {
    background-image: url('../assets/home.svg');
    background-size: contain;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    cursor: pointer;
  }
</style>
